module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/XRXW3I6Li01BKofAnsSUZevIWzgPDEtj.12e05030.woff2";